import apiUrl from "./config/config";
import axios from "axios";

class brandApi
{

  //Get brands
  static async getBrands(params)
  {

    try
    {

      const response = await axios(apiUrl + "brand", { params });

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }

  //Get a brand by id
  static async getBrand(id)
  {

    try
    {

      const response = await axios(apiUrl + `brand/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error();

    }

  }


  //Update a brand
  static async updateBrand(params)
  {

    try
    {

      const response = await axios.post(apiUrl + "brand", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Delete a brand
  static async deleteBrand(id)
  {

    try
    {

      const response = await axios.delete(apiUrl + `brand/${id}`);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

}






export default brandApi;